import { PersonalizationResourceType } from "@bloomberg/intercom";

import intercom from "~config/intercom";
import { Story } from "~types/types";

export const getPersonalizedStories = (story: Story) =>
    intercom.getRelated({
        useVectors: true,
        resourceTypes: [PersonalizationResourceType.Story],
        maxAge: 86400000,
        thumbnailRequired: true,
        currentResource: `Story|${story.id}`,
        excludedSites: "bview",
        limit: 2,
        filters: {
            exclude: {
                NI: "GLOBEWRP",
            },
        },
    });
